import React, { useState } from "react";
import { IconButton, Box, Modal, Tooltip } from "@mui/material";
import MovieCreationIcon from "@mui/icons-material/MovieCreation";
import TemplateDialog from "../TemplatesDialog";
import { Actor, HeygenTemplate } from "../../context/types";
import { template } from "lodash";

const ActorTemplateButton = ({
  actor,
  onTemplateChange,
}: {
  actor: Actor;
  onTemplateChange: (
    templateId: string,
    actorIds: string[],
    variables: any
  ) => Promise<void>;
}) => {
  const [open, setOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] =
    useState<HeygenTemplate | null>(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleTemplateApplied = async (
    templateId: string,
    actorIds: string[],
    variables: any
  ) => {
    await onTemplateChange(templateId, actorIds, variables);

    handleClose();
  };

  return (
    <>
      <Tooltip
        title={actor.heygenTemplate ? "Change template" : "Apply template"}
      >
        <IconButton onClick={handleOpen} size="small" sx={{ color: "#FFBF00" }}>
          <MovieCreationIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: 900,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 1,
          }}
        >
          <TemplateDialog
            open={open}
            onClose={handleClose}
            workspaceId={actor.workspace} // Assuming workspace is available on actor
            videoPageId={actor.videoPage} // Assuming videoPage is available on actor
            actors={[actor]} // Pass only the current actor
            onApplyTemplate={handleTemplateApplied}
            isSingleActorMode={true}
          />
        </Box>
      </Modal>
    </>
  );
};

export default ActorTemplateButton;
